let divs = document.querySelectorAll('quick-buy-drawer .swatch-products a');

  divs.forEach((el) =>
    el.addEventListener('click', (event) => {
      setTimeout(function () {
        const quickBuyDrawer = event.target.closest('quick-buy-drawer');
        const shadowRoot = quickBuyDrawer.shadowRoot;
        const quickBuyDrawerClose = shadowRoot.querySelector('[aria-label="Close"]');
        console.log(quickBuyDrawer);
        quickBuyDrawerClose.click();
      }, 200);
    })
  );

  // Swatch swap — vanilla (no jQuery dependency)
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('label.color-swatch');
    if (!swatch || !swatch.closest('.swatch-products') || swatch.classList.contains('current-product')) return;

    e.preventDefault();
    e.stopPropagation();

    var d = swatch.dataset;
    var productItem = swatch.closest('.product-card');
    if (!productItem) return;

    // Swap the primary image
    if (d.swatchProductImage) {
      var main_image = productItem.querySelector('.product-card__image--primary');
      if (main_image) {
        var newImageElement = document.createElement('img');
        newImageElement.className = 'product-card__image product-card__image--primary aspect-square';
        newImageElement.setAttribute('width', '1200px');
        newImageElement.setAttribute('height', '1600px');
        newImageElement.setAttribute('src', d.swatchProductImage);
        main_image.replaceWith(newImageElement);
      }
    }

    // Coerce data attributes (dataset is always a string)
    var variantTitle = d.variantTitle;
    var variantPrice = d.variantPrice;
    var variantComparePrice = d.variantComparePrice;
    var variantComparePriceValue = parseFloat(d.variantComparePriceValue) || 0;
    var variantFullPrice = d.variantFullPrice === 'true';
    var swatchProductAvailable = d.swatchProductAvailable === 'true';
    var swatchProductHandle = d.swatchProductHandle;
    var swatchProductQuickBuy = d.swatchProductQuickbuy;
    var variantQuickBuyButton = productItem.querySelector('.product-card__quick-buy button');

    var titleEl = productItem.querySelector('.product-card__info .product-card__title');
    if (titleEl) titleEl.innerHTML = variantTitle;

    var salePriceEl = productItem.querySelector('.product-card__info sale-price');
    if (salePriceEl) salePriceEl.innerHTML = variantPrice;

    var compareEl = productItem.querySelector('.product-card__info compare-at-price');
    if (compareEl) {
      if (variantComparePrice && variantComparePriceValue > 0) {
        compareEl.innerHTML = variantComparePrice;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.innerHTML = '';
        compareEl.setAttribute('hidden', '');
      }
    }

    if (variantQuickBuyButton) {
      var qb1 = productItem.querySelector('.product-card__quick-buy > div:nth-of-type(1) button');
      var qb2 = productItem.querySelector('.product-card__quick-buy > div:nth-of-type(2) button');
      if (qb1) qb1.setAttribute('aria-controls', swatchProductQuickBuy);
      if (qb2) qb2.setAttribute('aria-controls', swatchProductQuickBuy);
    }

    if (swatchProductHandle) {
      productItem.querySelectorAll('[data-quick-view-handle]').forEach(function (button) {
        button.setAttribute('data-quick-view-handle', swatchProductHandle);
      });
      var infoLinkElements = productItem.querySelectorAll('[data-product-info-link]');
      if (infoLinkElements && infoLinkElements.length > 0) {
        infoLinkElements.forEach(function (ele) {
          ele.setAttribute('href', '/products/' + swatchProductHandle);
        });
      }
    }

    // Show/hide Quick View buttons based on availability
    productItem.querySelectorAll('.js-quick-view-cta').forEach(function (button) {
      if (swatchProductAvailable) {
        button.style.display = '';
        button.removeAttribute('disabled');
      } else {
        button.style.display = 'none';
      }
    });

    // Sale styling
    if (salePriceEl) {
      if (variantComparePriceValue > 0 && variantFullPrice === false) {
        salePriceEl.classList.add('text-on-sale');
      } else {
        salePriceEl.classList.remove('text-on-sale');
      }
    }

    if (swatchProductAvailable) {
      productItem.classList.add('product-available');
    } else {
      productItem.classList.remove('product-available');
    }

    // Move the "current-product" marker to the clicked swatch
    var current = productItem.querySelector('.swatch-products label.color-swatch.current-product');
    if (current) current.classList.remove('current-product');
    swatch.classList.add('current-product');

    // Notify the carousel script of the variant change
    if (swatchProductHandle) {
      var changeEvent = new CustomEvent('product-card:variant-changed', {
        detail: { productCard: productItem, productHandle: swatchProductHandle },
        bubbles: true,
      });
      productItem.dispatchEvent(changeEvent);
    }
  });

  // Simple Color Swatch Size Retention
  document.addEventListener('DOMContentLoaded', function () {
    // Alternative function using selectedVariant (more efficient)
    function getCurrentVariantOptions() {
      const variantPicker = document.querySelector('variant-picker');
      const selectedOptions = variantPicker?.selectedVariant?.options;
      if (!variantPicker || !selectedOptions?.length) return null;

      return selectedOptions;
    }

    // Function to find variant ID in target product based on matching options
    function findMatchingVariantId(targetProductId, currentOptions) {
      if (!currentOptions?.length) return null;

      const allProducts = window.pdpData || [];

      // Find the target product by ID
      const targetProduct = allProducts.find((product) => product.id == targetProductId);
      if (!targetProduct?.variants) return null;

      // Get the number of options to match (excluding the first option which is usually color)
      const [, ...optionsToMatch] = currentOptions;

      return (
        targetProduct.variants.find((variant) =>
          optionsToMatch.every(
            (opt, i) => variant.options[i + 1] === opt // skip color at index 0
          )
        )?.id || null
      );
    }

    // Function to handle color swatch click
    function handleColorSwatchClick(swatch) {
      // Get current options
      const currentOptions = getCurrentVariantOptions();
      if (!currentOptions?.length) return;

      // Extract product ID from swatch ID (e.g., "id-8177242964155" -> "8177242964155")
      const match = swatch.id.match(/id-(\d+)/);
      if (!match) return;

      const targetProductId = match[1];

      // Find matching variant ID in target product
      const targetVariantId = findMatchingVariantId(targetProductId, currentOptions);
      if (!targetVariantId) return;

      // Update swatch href with variant param
      const baseUrl = swatch.getAttribute('href') || '';
      const separator = baseUrl.includes('?') ? '&' : '?';
      const finalUrl = `${baseUrl}${separator}variant=${targetVariantId}`;
      swatch.setAttribute('href', finalUrl);
    }

    // Add click listener to color swatches
    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('.swatch-link');
      if (swatch) handleColorSwatchClick(swatch);
    });
  });

  // GR27
  document.addEventListener('DOMContentLoaded', function () {
    const accordionFilters = document.querySelectorAll('.accordion.group');
  
    accordionFilters.forEach(function (accordion) {
      const checkboxList = accordion.querySelector('.checkbox-list');
      if (checkboxList) {
        const checkboxContainers = checkboxList.getElementsByClassName('checkbox-container');
        if (checkboxContainers.length <= 1) {
          accordion.style.display = 'none';
        }   
      }
    });
  });

  // GR35
  // Function to add styles conditionally for mobile
  function addMobileStyles() {
    const listItems = document.querySelectorAll('li');
    listItems.forEach((item) => {
      const textSpan = item.querySelector('.reversed-link');
      if (textSpan && textSpan.textContent.trim() === 'NEW RELEASES') {
        item.classList.add('highlight-with-border');
      }
    });
  }

  // Check and apply styles on document load
  document.addEventListener('DOMContentLoaded', function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
      addMobileStyles();
    }
  });

  // Apply styles on window resize 
  window.addEventListener('resize', function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
      addMobileStyles();
    }
  });
  
  // Hint a horizontal scroll on portals
  // document.addEventListener("DOMContentLoaded", function () {
  //   const container = document.getElementById('gr49-test');

  //   // Create the chevron dynamically
  //   const chevron = document.createElement('span');
  //   chevron.className = 'scroll-chevron';
  //   chevron.innerHTML = `
  //     <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
  //       <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
  //     </svg>
  //   `;   
  //   container.parentNode.appendChild(chevron); // Append to the .collection-portal

  //   function updateChevron() {
  //     // Check if the container is scrollable
  //     const isScrollable = container.scrollWidth > container.clientWidth;

  //     // Check if scrolled to the end
  //     const atEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;

  //     // Toggle chevron visibility
  //     if (isScrollable && !atEnd) {
  //       chevron.classList.remove('hidden');
  //     } else {
  //       chevron.classList.add('hidden');
  //     }
  //   }    

  //   // Update chevron on load, scroll, and resize
  //   updateChevron();
  //   container.addEventListener('scroll', updateChevron);
  //   window.addEventListener('resize', updateChevron);
  // });